import Store from 'store/store'
import { Component } from 'utils/jsx'
import Paper from 'components/dom/Paper'

export default class Papers extends Component {
  beforeRender () {
    this.handleScroll = this.handleScroll.bind(this)
    this.update = this.update.bind(this)
  }

  template () {
    return (
      <section class='papers' event-wheel={this.handleScroll}>
        <div class='papers__container' ref={this.ref('container')} />
      </section>
    )
  }

  afterRender () {
    this.state.hidden = this._parent.state.hidden

    Store.formats.subscribe(this.update)
    this.state.hidden.subscribe(this.update)
  }

  update () {
    // Iterate using the formats list so that papers order stays the same
    for (const format of Store.formats.get()) {
      const paper = Store.papers.current.get(format.name)

      if (paper) paper.state.hidden.set(!format.selected, true)
      if (format.selected && !paper) {
        this.render(
          <Paper
            name={format.name}
            format={format}
            ref={this.refArray('papers')}
          />,
          this.refs.container
        )
      }
    }

    this.renderPadHack()
  }

  renderPadHack () {
    this.refs.padHack && this.refs.padHack.remove()
    this.render(<div class='overflow-padding-hack' ref={this.ref('padHack')} />, this.refs.container)
  }

  handleScroll (e) {
    if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) return
    this.base.scrollLeft += e.deltaY
    e.preventDefault()
  }
}



// WEBPACK FOOTER //
// ./src/components/dom/Papers.js